import React, {useEffect, useState} from 'react';
import clientAPI from "../../service/ApiService";
import {Alert, Input} from 'antd';
import Row from "./HotelRow";

import Pagination from "../Common/Pagination";
import {getHotelsEndpoint} from "../../service/RoleService";

function HotelTable({refresh}) {

    const initialState = {
        page: 1,
        hotels: [],
        sizePerPage: 20,
        totalSize: 0,
        error: null,
        loading: false
    };
    const [state, setState] = useState(initialState);

    useEffect(() => {
        getHotels()
    }, [state.page, state.sizePerPage, refresh]);// eslint-disable-line react-hooks/exhaustive-deps

    const getHotels = (search=null) => {
        setState({
            ...state,
            error: null,
            loading: true,
        });

        let requestUrl = getHotelsEndpoint() +
            "?page=" + state.page +
            "&limit=" + state.sizePerPage +
            "&order=asc" +
            (search ? "&keyword=" + encodeURIComponent(search) : "");

        clientAPI.get(requestUrl)
            .then(response => {

                let hotels = response.data?.data;
                if(!hotels || hotels.length <= 0 ){
                    setState({...state,
                        hotels:[],
                        totalSize: 0,
                        page: state.page > 1 ? state.page-1 : state.page
                    });
                    return false
                }

                setState({
                    ...state,
                    error: null,
                    loading: false,
                    hotels: hotels,
                    totalSize: response.data.pagination.total
                })
            })
            .catch(error => {

                let msg = error?.response?.data?.statusCode?.msg
                setState({
                    ...state,
                    error: msg ?? null,
                    loading: false,
                    hotels: [],
                    totalSize: null
                })
            })
    }

    const goToPage = ((page) => {
        setState({
            ...state,
            page: page
        })
    });

    const { Search } = Input;
    const [timer, setTimer] = useState(null)


    const setSearch = (event) => {
        var searchText = event.target.value;

        if (timer != null) {
            clearTimeout(timer);
        }

        setTimer(
            setTimeout(() => {
                getHotels(searchText)
            }, 300)
        )
    }

    return (
        <div>
            {state.error && <Alert message={state.error} type="error" closable className="notification" />}
            <Search placeholder="Search hotel by id or name"
                    loading={state.loading}
                    onChange={(e) => setSearch(e)}
            />
            {state.hotels &&
            <div className={"table-wrapper ant-table"}>
                <table className="table">
                    <thead className={"ant-table-thead"}>
                    <tr>
                        <th scope="col" style={{ color:"black" }}>Id</th>
                        <th scope="col">Name</th>
                        <th scope="col">Country</th>
                        <th scope="col">Brand</th>
                    </tr>
                    </thead>
                    <tbody className={"ant-table-tbody"}>
                    {state.hotels.map((hotel, index) =>
                        <Row key={index} hotel={hotel} />
                    )}
                    </tbody>
                </table>
                <Pagination
                    sizePerPage={state.sizePerPage}
                    totalSize={state.totalSize}
                    page={state.page}
                    goToPage={goToPage}
                />
            </div>
            }
        </div>
    )
}


export default HotelTable;